<template v-if="facetsStore.facets">
    <template v-for="facet in facetsStore.facets">
        <div class="mb-1.5 border-b border-gray-300 pb-1.5">
            <h3 class="h6">
                {{ facet.title }}
            </h3>
            <ul class="grid grid-cols-1 gap-half md:grid-cols-2">
                <li v-for="(option, index) in facet.facetOptions" class="flex items-center" :class="index > 7 ? 'hidden' : ''">
                    <input 
                        type="checkbox" 
                        v-bind:id="option.id" 
                        v-bind:value="option.id"
                        data-param="facets"
                        v-model="option.checked"
                        class="border-gray-500 mr-[0.5rem] w-1 h-1 text-primary cursor-pointer"
                    >
                    <label v-bind:for="option.id"  class="mb-0 text-gray-700 cursor-pointer">{{ option.title }}</label>
                </li>
                <button 
                    v-if="facet.facetOptions.length > 8"
                    class="underline mt-0.75 text-left font-bold text-primary hover:text-primary-light focus:text-primary-light"
                    v-on:click="showMore"
                >   
                    Show more
                </button>
            </ul>
        </div>
    </template>
</template>